export const ParentType = Object.freeze({
  CLIENT: "client",
  PORTFOLIO: "portfolio",
  PROGRAM: "program",
  PROJECT: "project",
});

/**
 * All available KPI / column keys.
 * Each entry drives: KPI cards, chart bars/lines, and table columns.
 */
export const REPORT_COLUMNS = [
  { key: "resources",         label: "Resources",       order: 1,  isVisible: true },
  { key: "capacityHours",     label: "Capacity",        order: 2,  isVisible: true },
  { key: "allocationHours",   label: "Allocation",      order: 3,  isVisible: true },
  { key: "loggedHours",       label: "Logged",          order: 4,  isVisible: true },
  { key: "utilization",       label: "Utilization",     order: 5,  isVisible: true },
  { key: "loggedUtilization", label: "Logged Util",     order: 6,  isVisible: true },
  { key: "allocCost",         label: "Alloc Cost",      order: 7,  isVisible: true },
  { key: "loggedCost",        label: "Logged Cost",     order: 8,  isVisible: true },
  { key: "costVariance",      label: "Cost Variance",   order: 9,  isVisible: true },
  { key: "allocBill",         label: "Alloc Bill",      order: 10, isVisible: true },
  { key: "loggedBill",        label: "Logged Bill",     order: 11, isVisible: true },
  { key: "billVariance",      label: "Bill Variance",   order: 12, isVisible: true },
  { key: "allocGp",           label: "Alloc GP",        order: 13, isVisible: true },
  { key: "loggedGp",          label: "Logged GP",       order: 14, isVisible: true },
];

/**
 * Build the layout name for the user-layout API.
 * @param {string|null} parentType - One of ParentType values, or null
 * @returns {string}
 */
export function getLayoutName(parentType) {
  return parentType ? `${parentType}-resources-reports` : "resources-reports";
}
